import React from 'react';

//hooks
import { UseTeams } from '../../hooks/UseTeams';

//components
import Loading from '../common/Loading';
import Passport from './Passport';
import Teams from './Teams';

const Home = () => {

    const [loading, teams] = UseTeams();    
    
    return (
        <section className="w-100 cont-principal">
            <Passport />  
            {
                loading 
                ? <Loading />
                : <Teams teams={teams} />        
            }              
        </section>
    )
}

export default Home;